import { Time } from 'lib-utils';
import Vue from 'vue';

//  time 单位为秒
export function GuruTimeFormat(time) {
  return Time.GuruTimeFormat(time);
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') {
      return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

export function complet(value) {
  if (value >= 0 && value < 10) {
    value = '0' + value;
  }
  return value;
}

export function formatTime(time, option) {
  time = time * 1000; //  转换成单位毫秒
  const d = new Date(time);
  const now = Date.now();
  const diff = (now - d) / 1000;

  const zero = new Date(new Date().toLocaleDateString()).getTime();
  const dZero = new Date(new Date(time).toLocaleDateString()).getTime();
  const sameDay = zero === dZero; // 判断是否为当天

  const sameYear = new Date().getFullYear() === new Date(time).getFullYear();
  const year = d.getFullYear();
  const month = complet(d.getMonth() + 1);
  const day = complet(d.getDate());
  const hours = complet(d.getHours());
  const minutes = complet(d.getMinutes());

  if (!sameYear) {
    return `${year}年${month}月${day}日 ${hours}时${minutes}分`;
  }

  if (sameDay) {
    if (diff < 60) {
      return '刚刚';
    } else if (diff < 3600) {
      //  less 1 hour
      return Math.ceil(diff / 60) + '分钟前';
    } else if (diff < 3600 * 24) {
      //  less
      return Math.floor(diff / 3600) + '小时前';
    }
  } else {
    if (zero - dZero === 1000 * 3600 * 24) {
      return `昨天 ${hours}:${minutes}`;
    } else if (zero - dZero === 1000 * 3600 * 24 * 2) {
      return `前天 ${hours}:${minutes}`;
    } else {
      return `${month}-${day} ${hours}:${minutes}`;
    }
  }

  if (option) {
    return parseTime(time, option);
  } else {
    return `${year}年${month}月${day}日 ${hours}时${minutes}分`;
  }
}
// XXXX-XX-XX格式
export function formatDayTime(time) {
  time = time * 1000; // 转换成单位毫秒
  const d = new Date(time);
  const year = d.getFullYear();
  const month = complet(d.getMonth() + 1);
  const day = complet(d.getDate());

  return `${year}-${month}-${day}`;
}

export function siederBarformatTime(time, option) {
  time = time * 1000; //  转换成单位毫秒
  const d = new Date(time);
  const now = Date.now();
  const diff = (now - d) / 1000;

  const zero = new Date(new Date().toLocaleDateString()).getTime();
  const dZero = new Date(new Date(time).toLocaleDateString()).getTime();
  const sameDay = zero === dZero; // 判断是否为当天

  const diffDay = (zero - dZero) / (1000 * 3600 * 24);

  if (sameDay) {
    if (diff < 60) {
      return '刚刚';
    } else if (diff < 3600) {
      //  less 1 hour
      return Math.ceil(diff / 60) + '分钟前';
    } else if (diff < 3600 * 24) {
      //  less
      return Math.ceil(diff / 3600) + '小时前';
    }
  } else {
    if (Math.ceil(diffDay) > 0 && Math.ceil(diffDay) < 31) {
      return `${diffDay}天前`;
    } else if (diffDay / 30 < 12) {
      return `${Math.ceil(diffDay / 31)}个月前`;
    } else {
      return (
        complet(d.getMonth() + 1) +
        '-' +
        complet(d.getDate()) +
        '  ' +
        complet(d.getHours()) +
        ':' +
        complet(d.getMinutes())
      );
    }
  }

  //  if (option) {
  //    return parseTime(time, option)
  //  } else {
  //    return d.getFullYear() + '年' + complet((d.getMonth() + 1)) + '月' + d.getDate() + '日' + complet(d.getHours()) + '时' + complet(d.getMinutes()) + '分'
  //  }
}

//  export function ossImageProcess(urlString, width, height, quality = 60) {

//    if (''.includes('@') || ''.includes('!')) return toString

//    let maxLength = 4096
//    let scale = window.devicePixelRatio
//    let exactWidth = Math.min(width * scale, maxLength)
//    let exactHeight = Math.max(height * scale, maxLength)

//    let url = new URL(urlString)
//    url.searchParams.set('x-oss-process', 'image/resize,m_mfit,h_' + exactHeight + ',w_' + exactWidth + '/quality,Q_' + quality)

//    return url.toString()
//  }

/**
 * @description 对数字做千位分隔
 * @param { number } num 处理数字
 * @returns { string } 格式化后的数字
 */
export const numFormat = (num) => {
  const res = num.toString().replace(/\d+/, (n) => {
    //  先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, ($1) => {
      return `${$1},`;
    });
  });
  return res;
};

const filters = {
  formatTime,
  siederBarformatTime,
  GuruTimeFormat,
  numFormat,
  formatDayTime,
};

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

export default filters;
